import { render, staticRenderFns } from "./TestimonialCards.vue?vue&type=template&id=4f51fb9e&"
import script from "./TestimonialCards.vue?vue&type=script&lang=ts&"
export * from "./TestimonialCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports